@import '../../style/layout/index';
@import '~bulma/sass/grid/columns';

$default-columns-spacing: 128px;
$large-columns-spacing: 194px;

/* This class is being extended from the ".columns" class from bulma */
/* stylelint-disable-next-line selector-class-pattern */
.columns {
  box-sizing: border-box; // Bulma relies on inherited styles for this rule.

  &.is-multiple-row {
    flex-wrap: wrap;
  }
}
